import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'mwe-product-card-tariff-list-fernwaerme',
  templateUrl: './product-card-tariff-list-fernwaerme.component.html',
  imports: [LowerCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardTariffListFernwaermeComponent {
  tariffClasses = input<string[]>();
}
